import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";

let defaultContext;

/**
 * This is singleton used to initialize only once dnd in our app.
 * If you initialized dnd and then try to initialize another dnd
 * context the app will break.
 * Here is more info: https://github.com/gaearon/react-dnd/issues/186
 *
 * The solution is to call Dnd context from this singleton this way
 * all dnd contexts in the app are the same.
 */
export default function getDndContext() {
  if (defaultContext) return defaultContext;

  defaultContext = new DragDropContext(HTML5Backend);

  return defaultContext;
}



// WEBPACK FOOTER //
// ./src/components/DndContext.jsx